<template>
  <div class="manageIndex div-layout">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="课桌设备启用管理" name="first">
        <equipManage />
      </el-tab-pane>
      <el-tab-pane label="课桌绑定配置版本" name="second">
        <bindBatch />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import equipManage from './equipManage.vue';
import bindBatch from './bindBatch.vue';
export default {
  name: 'MrdeskDevicManage',
  components: {
    equipManage,
    bindBatch
  },
  data() {
    return {
      activeName: this.$route.query.backName ? this.$route.query.backName : 'first'
    };
  },
  mounted() {
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped>
.manageIndex{
  padding: 0 20px;
}
</style>
